import * as React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import Card from '../../../../common/components/card';
import { Button } from '../../../../common/components/button';
import UserInput from '../../../../common/components/user-input';
import { PostMessageForm } from '../../forms/post-message';
import NetworkFilterPanel from './network-filter-panel';
import {
  Props, State,
  HandleFocus, HandleBlur, HandleSelectTimeline, HandleClearTimeline, HandleReset, HandleSearch,
} from './types';
import { ETimelineTypes } from '@modules/social/definitions';

class PostMessageComponent extends React.Component<Props, State> {
  static props: Props;

  handleFocus: HandleFocus;
  handleBlur: HandleBlur;
  handleSelectTimeline: HandleSelectTimeline;
  handleClearTimeline: HandleClearTimeline;
  handleReset: HandleReset;
  handleSearch: HandleSearch;

  constructor(props: Props) {
    super(props);

    this.state = {
      initialised: false,
      focused: false,
      timeline: props.disableHeader && props.channel
        ? props.channel
        : null,
      search: '',
      showMoreNetworks: false,
    };

    this.handleFocus = () => {
      document.body.style.overflow = 'hidden';
      this.setState({
      focused: true,
      initialised: true,
      timeline: this.state.timeline === null
        // @ts-expect-error
        ? this.props.channel.type !== ETimelineTypes.FEED ? this.props.channel : null
        : this.state.timeline,
    });
  };
    this.handleBlur = () => {
      document.body.style.overflow = '';
      this.setState({ focused: false, search: '' });
    };
    this.handleSelectTimeline = (type, id, parent) => this.setState({ timeline: { type, id, parent } });
    this.handleClearTimeline = () => this.setState({ timeline: null });
    this.handleReset = () => {
      document.body.style.overflow = '';
      this.setState({
      focused: false,
      initialised: false,
      timeline: null,
    });
  };
    this.handleSearch = (query) => this.setState({ search: query ? query.toLowerCase() : '' });
  }

  // @ts-expect-error
  UNSAFE_componentWillUpdate(nextProps) {
    const { channel } = this.props;

    // @ts-expect-error
    if (this.state.timeline && `${nextProps.channel.type}${nextProps.channel.id}` !== `${channel.type}${channel.id}`) {
      // @ts-expect-error
      this.state.timeline = nextProps.channel.type !== ETimelineTypes.FEED ? nextProps.channel : null;
    }
  }

  renderFocusedContent() {
    const { search, showMoreNetworks } = this.state;
    const {
      organisation, networks, organisationTeams, t,
    } = this.props;

    // @ts-expect-error
    const inSearch = (item) => item.name.toLowerCase().indexOf(search) !== -1;
    const channels = this.props.channels.filter(inSearch);

    return (
      <NetworkFilterPanel
        search={search}
        showMoreNetworks={showMoreNetworks || false}
        networks={networks || []}
        organisationTeams={organisationTeams || []}
        channels={channels}
        organisation={organisation}
        t={t}
        onSearch={this.handleSearch}
        onSelectTimeline={this.handleSelectTimeline}
        onToggleShowMore={() => this.setState({ showMoreNetworks: !showMoreNetworks })}
      />
    );
  }

  render() {
    const { initialised, focused, timeline, } = this.state;
    const {
      loggedUser, disableHeader, t,
    } = this.props;

    let content;

    if (((!timeline && !focused) || !initialised)) {
      content = (
        <Card.Content>
          <UserInput user={loggedUser}>
            <textarea
              style={{ width: '100%', height: 18 }}
              className="Form__control__highlighter"
              placeholder={t('social:post_message_placeholder')}
            />
          </UserInput>
          <hr />
          <div className="PostMessage__Actions">
            <Button className="PostMessage__Button--poll" icon="poll__filled">
              <Trans i18nKey="social:post_message_poll" />
            </Button>
            <Button className="PostMessage__Button--attachment" icon="image__filled">
              <Trans i18nKey="social:post_message_attachment_photo_video" />
            </Button>
            <Button className="PostMessage__Button--document" icon="document__filled">
              <Trans i18nKey="social:post_message_attachment_document" />
            </Button>
            <Button icon="more_horiz" />
          </div>
        </Card.Content>
      );
    } else if (!timeline && focused) {
      content = this.renderFocusedContent();
    } else if (timeline) {
      content = (
        <>
          {!disableHeader && (
            <Card.Header>
              <Trans i18nKey="social:post_message_post_in" />
              &nbsp;
              {/* @ts-expect-error */}
              <span className="Post__Message__TargetName">{timeline.parent.name}</span>
              &nbsp;
              {/* @ts-expect-error */}
              {timeline.parent.users_count !== undefined && (
                <>
                  {/* @ts-expect-error */}
                  (<Trans i18nKey="social:post_message_target_users_count" values={{ count: timeline.parent.users_count }} />)
                </>
              )}
              <div className="Post__Message__ChangeTarget pull-right" onClick={this.handleClearTimeline}>
                <Trans i18nKey="social:post_message_change_target" />
              </div>
            </Card.Header>
          )}
          <PostMessageForm
            {...this.props}
            // @ts-expect-error
            timeline={timeline}
            isFocused={focused}
            postPostMessage={this.handleReset}
          />
        </>
      );
    }

    const containerClassNames = ['PostMessage'];
    if (focused) containerClassNames.push('PostMessage--focused');

    return (
      <>
        {focused && <div className="PostMessage__Backdrop" role="dialog" onClick={this.handleBlur} />}
        <Card containerClassName={containerClassNames.join(' ')} onClick={!focused ? this.handleFocus : undefined}>
          {content}
        </Card>
      </>
    );
  }
}

export default withTranslation(undefined, { withRef: true })(PostMessageComponent);
